import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  transactions: [],
  isLoading: true,
  isViewModalOpen: false,
  isDeleteModalOpen: false,
  viewSingleTransaction: {},
};

export const fetchTransactions = createAsyncThunk(
  "transaction/fetchTransactions",
  () => {
    return axios
      .get("https://62de2ff379b9f8c30ab47809.mockapi.io/transactions")
      .then((response) => response.data);
  }
);

const transactionSlice = createSlice({
  name: "transaction",
  initialState,
  reducers: {
    viewTransaction: (state, action) => {
      state.isViewModalOpen = true;
      state.viewSingleTransaction = action.payload;
    },
    openDeleteModal: (state, action) => {
      state.isDeleteModalOpen = true;
      state.viewSingleTransaction = action.payload;
    },
    closeModal: (state) => {
      state.isViewModalOpen = false;
      state.isDeleteModalOpen = false;
      state.viewSingleTransaction = {};
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchTransactions.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchTransactions.fulfilled, (state, action) => {
      state.isLoading = false;
      state.transactions = action.payload;
      state.error = "";
    });
    builder.addCase(fetchTransactions.rejected, (state, action) => {
      state.isLoading = false;
      state.transactions = [];
      state.error = action.error.message;
    });
  },
});

export const { viewTransaction, openDeleteModal, closeModal } =
  transactionSlice.actions;
export default transactionSlice.reducer;
